import { axiosPost } from "./AxiosAPI";

export const postPaymentParams = async (json) => {
    const url = `api/buy/payment-params`;
    return axiosPost(url, json);
}